import React from 'react';
import { Navigate } from 'react-router';
import Base from '../Base';
import { Header } from '../Header';
import { Footer } from '../Footer';
import DatePicker from 'react-datepicker2';

export default class Organization extends Base {
    constructor(props) {
        super(props);
        this.state = {
            id: props.Id,
            data: null,
            loading: true
        }
    }
    componentDidMount() {
        this.httpPost("api/v1/organization/get", {
            id: this.getCurrentFormId()
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 0) {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
                else {
                    this.setState({
                        data: data,
                        loading: false
                    })
                }
            });
    }
    save(e) {
        e.preventDefault();
        this.httpPost("api/v1/organization/save", {
            id: this.getCurrentFormId(),
            name: this.state.data.record.name,
            planId: this.state.data.record.planId,
            planAssignDate: this.convertMomentToDb(this.state.data.record.planAssignDate)
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.showSuccessMessage("اطلاعات با موفقیت ذخیره شد");
                    this.setState({
                        redirect: '/organizations/'
                    });
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    renderForm() {
        if (this.state.data.status == -2) return this.renderSystemModuleNotFound();
        if (this.state.data.status == -3) return this.renderSystemModuleExpired();

        return <form method="post" onSubmit={e => this.save(e)} className="nk-content ">
            <div className="container-fluid">
                <div className="nk-content-inner">
                    <div className="nk-content-body">
                        <div className="components-preview wide-md mx-auto">
                            <div className="nk-block nk-block-lg">
                                <div className="card card-bordered">
                                    <div className="card-inner">
                                        <ul className="nav nav-tabs mt-n3">
                                            <li className="nav-item">
                                                <a className="nav-link active" data-bs-toggle="tab" href="#base"><em className="icon ni ni-info"></em><span>اطلاعات کسب و کار</span></a>
                                            </li>
                                        </ul>
                                        <div className="tab-content">
                                            <div className="tab-pane active" id="base">
                                                <div className="row g-4">
                                                    <div className="col-lg-3">
                                                        <div className="form-group">
                                                            <label className="form-label">پلن</label>
                                                            <div className="form-control-wrap">
                                                                <select className="form-control" defaultValue={this.state.data.record.planId} onChange={e => this.state.data.record.planId = parseInt(e.target.value)}>
                                                                    <option value="0">فاقد پلن</option>
                                                                    {this.state.data.plans.map(plan =>
                                                                        <option value={plan.id}>{plan.title}</option>
                                                                    )}
                                                                </select>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-sm-2">
                                                        <div className="form-group">
                                                            <label className="form-label">فعال سازی</label>
                                                            <DatePicker
                                                                inputReadOnly={false}
                                                                className="form-control persian-date ltr"
                                                                placeholder={"تاریخ"}
                                                                isGregorian={false}
                                                                showTodayButton={true}
                                                                timePicker={false}
                                                                onChange={(e) => { this.state.data.record.planAssignDate = e }}
                                                                value={this.getFormatedDateForDatePicker(this.state.data.record.planAssignDate)}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-7">
                                                        <div className="form-group">
                                                            <label className="form-label">عنوان</label>
                                                            <div className="form-control-wrap">
                                                                <input className="form-control" maxLength="100" type="text" defaultValue={this.state.data.record.name} onChange={e => this.state.data.record.name = e.target.value} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-lg-12">
                                                <div className="form-group" style={{ "marginTop": "15px" }}>
                                                    <button type="submit" className="btn btn-lg btn-primary">ذخیره</button>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                <Header data={this.state.data} />,
                <div className="nk-content ">
                    <div className="container-fluid">
                        <div className="nk-content-inner">
                            {this.renderForm()}
                        </div>
                    </div>
                </div>,
                <Footer />
            ];

        return contents;
    }
}